import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

type ServiceCardProps = {
  title: string;
  slug: string;
  category: string;
  image: string;
  excerpt: string;
};

export default function ServiceCard({ title, slug, category, image, excerpt }: ServiceCardProps) {
  return (
    <article className="surface-card group overflow-hidden">
      <Link to={`/services/${slug}`} className="block">
        <div className="image-frame aspect-[4/3]">
          <img src={image} alt={title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
        </div>
        <div className="p-5">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-primary-700">{category}</p>
          <h2 className="mt-2 font-heading text-2xl font-bold leading-tight text-foreground-950">{title}</h2>
          <p className="mt-3 line-clamp-3 text-sm leading-7 text-foreground-700">{excerpt}</p>
          <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary-700">
            View service
            <ArrowRight size={16} />
          </span>
        </div>
      </Link>
    </article>
  );
}
